import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'

import Observer from '../components/observer'

class Downloads extends Component {

  constructor(element) {

    super(element)

    this.element = element

    this.index = 0


    this.ref = {
      eu: null, 
      us: null,
      ustab: null,
      eutab: null
    }

  }

  mount() {

    this.ref.us.addEventListener('click', (e) => {
      e.preventDefault()
        this.ref.eutab.classList.remove('download-wrapper--visible')
        this.ref.eu.classList.remove('but-active')

        this.ref.ustab.classList.add('download-wrapper--visible')
        this.ref.us.classList.add('but-active')

      })

      this.ref.eu.addEventListener('click', (e) => {
        e.preventDefault()
        this.ref.ustab.classList.remove('download-wrapper--visible')
        this.ref.us.classList.remove('but-active')

        this.ref.eutab.classList.add('download-wrapper--visible')
        this.ref.eu.classList.add('but-active')

      })
}






  unmount() {




  }


}

module.exports = Downloads
